import { FilterConditions, INSERT, SELECT, UPDATE , execute } from "@/utils/database_module"
import { logDebug } from "@/utils/helpers"
import { Devis, Order, Product } from "@/utils/types"

const invoices = {
    getAll : async () => {
        const invoices = await SELECT("devis" , { conditions : [{column : "is_deleted" , operator : "=" , value : 0}] , order : "date DESC"})
        return invoices
    },


    insert: async (invoiceToInsert: Omit<Devis, "id" | "date" | "modified_date" | "is_deleted">) => {
        const conditions = [ { column: "is_deleted", operator: "=", value: 0 }, { column: "product_ref", operator: "=", value: invoiceToInsert.product_ref }, ] as FilterConditions;
        const invoices = await SELECT("devis", { conditions }) as Devis[];
        const containedRange = invoices.find((invoice) => {
            const isMinContained = invoice.min_quantity <= invoiceToInsert.min_quantity;
            const isMaxContained = invoice.max_quantity >= invoiceToInsert.max_quantity;
            
            return isMinContained && isMaxContained;
        });
        
        if (containedRange) {
            throw new Error( 
                `L'intervalle choisi est contenu dans un intervalle déjà existant : ` +
                `[${containedRange.min_quantity}, ${containedRange.max_quantity}] ` + 
                `prix unitaire: ${containedRange.price}` 
            ); 
        }
    
        const overlappingRange = invoices.find((invoice) => {
            const isLeftOverlapping = invoiceToInsert.min_quantity < invoice.min_quantity && invoiceToInsert.max_quantity >= invoice.min_quantity && invoiceToInsert.max_quantity < invoice.max_quantity;
            const isRightOverlapping = invoiceToInsert.min_quantity > invoice.min_quantity && invoiceToInsert.min_quantity <= invoice.max_quantity && invoiceToInsert.max_quantity > invoice.max_quantity;
            return isLeftOverlapping || isRightOverlapping;
        });
    
        if (overlappingRange) {
            throw new Error(
                `L'intervalle choisi se chevauche avec un intervalle déjà existant : ` +
                `[${overlappingRange.min_quantity}, ${overlappingRange.max_quantity}] ` +
                `prix unitaire: ${overlappingRange.price}`
            );
        }
    
        const containerRange = invoices.find((invoice) => {
            const isContainedWithin = invoiceToInsert.min_quantity < invoice.min_quantity &&
                                      invoiceToInsert.max_quantity > invoice.max_quantity;
            return isContainedWithin;
        });
    
        if (containerRange) {

            throw new Error(
                `Un intervalle déjà existant est contenu dans l'intervalle choisi : ` +
                `[${containerRange.min_quantity}, ${containerRange.max_quantity}] ` +
                `prix unitaire: ${containerRange.price}`
            );
        }
    
        const existingRange = invoices.find((invoice) => {
            const isExactMatch = invoice.min_quantity == invoiceToInsert.min_quantity && invoice.max_quantity == invoiceToInsert.max_quantity;
            return isExactMatch;
        });
        if (existingRange) {
            await UPDATE("devis", invoiceToInsert, [{ column: "id", operator: "=", value: existingRange.id }]);
        } else {
            await INSERT("devis", invoiceToInsert);
        }
    
        const products = (await SELECT("products", {
            columns: ["id", "reference"],
            conditions: [{ column: "reference", operator: "=", value: invoiceToInsert.product_ref }],
        })) as Product[];
    
        const productsIds = products.map((p) => p.id).join(", ");
        const orders =productsIds ? await execute( `SELECT * FROM orders  WHERE product_id IN (${productsIds})  AND quantity > ${invoiceToInsert.min_quantity - 1}  AND quantity < ${invoiceToInsert.max_quantity - 1}  AND status = 1  AND is_special = 0` ) as Order[] : [];
    
        if (orders.length === 0) return;
    
        for (const order of orders) {
            await UPDATE(
                "orders",
                { total_price: order.quantity! * invoiceToInsert.price, unit_price: invoiceToInsert.price, status: 2 },
                [{ column: "id", operator: "=", value: order.id! }]
            );
        }
    },
    

    update : async (id : number , devis : Partial<Devis>) => {
        return await UPDATE("devis" , devis , [{column : "id" , operator : "=" , value : id}])
    },

    delete : async (id : number) => {
        return await UPDATE("devis" , { is_deleted : 1 } , [{column : "id" , operator : "=" , value : id}])
    },
}   

export default invoices